import React from 'react';
import { TrackPricing } from '../../hooks/useTrackData';
import { formatCurrency } from '../../lib/currencyUtils';

interface PricingOptionsProps {
  pricing: TrackPricing[];
  selectedPricing: TrackPricing | null;
  setSelectedPricing: (pricing: TrackPricing) => void;
  loading: boolean;
  openDateTimeModal?: (pricing: TrackPricing) => void;
}

const PricingOptions: React.FC<PricingOptionsProps> = ({ 
  pricing, 
  selectedPricing, 
  setSelectedPricing, 
  loading,
  openDateTimeModal
}) => {
  if (loading) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">Loading pricing options...</p>
      </div>
    );
  }

  const handlePricingClick = (option: TrackPricing) => {
    setSelectedPricing(option);
    if (openDateTimeModal) {
      openDateTimeModal(option);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {pricing.map((option) => (
        <div 
          key={option.id} 
          className={`bg-zinc-900 rounded-lg p-6 hover:transform hover:-translate-y-1 transition-all duration-300 cursor-pointer ${
            selectedPricing?.id === option.id ? 'ring-2 ring-primary-500' : ''
          }`}
          onClick={() => handlePricingClick(option)}
        >
          <h3 className="text-xl font-bold text-white mb-2">{option.title}</h3>
          <p className="text-3xl font-bold text-primary-500 mb-2">{formatCurrency(option.price)}</p>
          <p className="text-yellow-500 text-sm mb-4">
            Security Deposit: {formatCurrency(option.deposit_amount)} ({option.deposit_percentage}%)
          </p>
          <p className="text-gray-400 mb-6">{option.description}</p>
          <div className="flex flex-wrap gap-2 mb-6">
            <span className="px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
              {option.duration_hours} {option.duration_hours === 1 ? 'Hour' : 'Hours'}
            </span>
            {option.use_traction_compound && (
              <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                Traction Compound
              </span>
            )}
            {option.blocks_full_day && (
              <span className="px-2 py-1 text-xs font-semibold rounded-full bg-purple-100 text-purple-800">
                Full Day Event
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PricingOptions;